module.exports = __webpack_public_path__ + "img/circle_miscellaneous.156b4a9a.svg";